import { Component, OnInit } from '@angular/core';
import { SidebarService } from 'shared/services/sidebar.service';

//import { Observable } from 'rxjs';

@Component({
  selector: 'app-sidebar-nav-container',
  templateUrl: './sidebar-nav-container.component.html',
  styleUrls: ['./sidebar-nav-container.component.scss'],
})
export class SidebarNavContainerComponent implements OnInit {
  expanded: boolean;

  constructor(private sidebarService: SidebarService) { }

  ngOnInit() {
    this.sidebarService.isMenuExpanded$().subscribe(msg => {
      this.expanded = msg;
      document.getElementById('sidebar-menu').style.width = this.expanded ? "240px" : "auto";
    });
  }

  onExpanderClick(): void {
    this.sidebarService.toggleMenuExpanded();
  }
}

export { SidebarService };
